<div class="login-screen" id="myCheck" *ngIf="!auth">
  <div class="login-wrapper">
    <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="login-logo"></div>
      </div>

      <mat-form-field class="form-field-position" hideRequiredMarker>
        <mat-label><span translate>Email :</span></mat-label>
        <input matInput id="email-input" emailInput type="email" name="email" [formControl]="emailFormControl"
          [readonly]="canLoginSSO && step === 'password'">
        <mat-error *ngIf="emailFormControl.dirty &&  emailFormControl.hasError('email')"
          transalte>login.Email
          is invalid</mat-error>
      </mat-form-field>

      <!-- Flux en 2 étapes (SSO) : réservé aux projets avec canLoginSSO actif sur la route -->
      <ng-container *ngIf="canLoginSSO; else singleStepPassword">
        <!-- Étape 1 : vérification du domaine (SSO ou mot de passe) -->
        <div *ngIf="step === 'email'">
          <button *ngIf="!checkingSso" [disabled]="!emailFormControl.valid" type="submit" class="login-btn"
            translate>login.continuer</button>
          <div *ngIf="checkingSso" class="row center">
            <mat-spinner diameter="24"></mat-spinner>
          </div>
        </div>

        <!-- Étape 2 : mot de passe (domaine sans SSO) -->
        <ng-container *ngIf="step === 'password'">
          <div class="row">
            <button type="button" (click)="backToEmailStep()" class="change-email-btn" translate>login.changerEmail</button>
          </div>
          <ng-container *ngTemplateOutlet="singleStepPassword"></ng-container>
        </ng-container>
      </ng-container>

      <!-- Flux classique (email + mot de passe en une seule étape) -->
      <ng-template #singleStepPassword>
        <mat-form-field class="form-field-position" hideRequiredMarker>
          <mat-label><span translate>login.Mot de passe</span></mat-label>
          <input matInput id="password-input" #pwdInput type="password" name="password" autocomplete="off"
            [formControl]="passwordFormControl">
          <mat-error *ngIf="passwordFormControl.dirty && !passwordFormControl.valid" translate>{{translatePath}}.Password
            is invalid</mat-error>
        </mat-form-field>

        <div>
          <button *ngIf="!loading" [disabled]="!userForm.valid" type="submit" class="login-btn"
            translate>login.connexion</button>
        </div>
      </ng-template>
    </form>
    <div class="row">
      <button *ngIf="!loading" (click)="lostPassword()" class="forgot-btn" translate>{{translatePath}}.Mot de passe
        oublié ?</button>
    </div>
    <div *ngIf="loading" class="row center">
      <span translate>teacher.login.loading</span>
    </div>
  </div>
</div>